import { DOCUMENT, inject, Injectable } from '@angular/core';
import { InitialLoaderService } from '@services/initial-loader/initial-loader';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  protected location = inject(DOCUMENT).location;
  protected _name = '';

  protected readCompanyNameFromDomain(): string | null {
    const baseDomain = environment.baseDomain;
    const host: string = this.location.host;
    const baseDomainForRegexp = baseDomain.replace(/\./g, '\\.');
    const domainRegexp = new RegExp(`^([a-z0-9_-]+)\.${baseDomainForRegexp}$`);
    const match = host.match(domainRegexp);

    if (!match || !match[1]) {
      return null;
    }

    return match[1];
  }

  protected set name(value: string) {
    this._name = value;
  }

  get name(): string {
    return this._name;
  }

  init() {
    const domainCompanyName = this.readCompanyNameFromDomain();
    if (domainCompanyName) {
      this.name = domainCompanyName;
      return;
    }

    InitialLoaderService.showError('no company_system_name provided');
    throw new Error('no company_system_name provided');
  }
}
